import type {ValueEditorAliasesService} from '../aliases/value-editor-aliases.service';
import type {ValueEditorType, ValueEditorTypeMap} from '../types';
import {ValueEditorConfigurationManager} from './value-editor-configuration.manager';
import type {DefaultOptions} from '../types';

export class ValueEditorConfigurationManagerProvider {
    public static serviceName = 'valueEditorConfigurationManagerProvider';

    private configurationManagersByType: Map<ValueEditorType, ValueEditorConfigurationManager> = new Map();

    /*@ngInject*/
    constructor(private valueEditorAliasesService: ValueEditorAliasesService) {
    }

    public registerForType<TYPE extends keyof ValueEditorTypeMap>(type: TYPE, defaultConfiguration: DefaultOptions<ValueEditorTypeMap[TYPE]['options']>): ValueEditorConfigurationManagerProvider {
        this.configurationManagersByType.set(type, new ValueEditorConfigurationManager<ValueEditorTypeMap[TYPE]['options']>(this.valueEditorAliasesService, defaultConfiguration));
        return this;
    }

    public getManagerForType<TYPE extends keyof ValueEditorTypeMap>(type: TYPE): ValueEditorConfigurationManager<ValueEditorTypeMap[TYPE]['options']> {

        if (!this.configurationManagersByType.has(type)) {
            throw new Error(`Unable to resolve config manager of type: ${type}`);
        }

        return this.configurationManagersByType.get(type) as ValueEditorConfigurationManager<ValueEditorTypeMap[TYPE]['options']>;
    }
}
